import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export default async function patchHotSwapRecordWithNewAssignment(
  recordId,
  assignmentId,
  recordClockOutAttributes
) {
  const apiPath = `records/${recordId}/hot-swap-record-with-new-assignment`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { assignmentId, recordClockOutAttributes },
  });

  const response = await axios(signedRequest);

  return response.data;
}
